(function () {
  function init360(root) {
    if (!root || root.dataset.p360Inited === "1") return;

    const raw = root.getAttribute("data-frames") || "";
    const frames = raw.split("|").filter(Boolean);
    if (frames.length < 2) return;

    const img = root.querySelector(".p360__img");
    if (!img) return;

    const sensitivity = parseInt(root.getAttribute("data-sensitivity") || "12", 10) || 12;

    frames.forEach(src => { const i = new Image(); i.src = src; });

    let idx = 0;
    img.src = frames[0];

    let dragging = false, lastX = 0, accum = 0;

    function setFrame(i) {
      idx = (i % frames.length + frames.length) % frames.length;
      img.src = frames[idx];
    }

    function start(x, e) {
      e.preventDefault();
      e.stopPropagation();  // important with carousel
      dragging = true;
      lastX = x;
      accum = 0;
      root.classList.add("is-dragging");
    }

    function move(x, e) {
      if (!dragging) return;
      e.preventDefault();
      e.stopPropagation();
      const dx = x - lastX;
      lastX = x;
      accum += dx;

      const step = (accum / sensitivity) | 0;
      if (step !== 0) {
        accum -= step * sensitivity;
        setFrame(idx - step);
      }
    }

    function end() {
      dragging = false;
      root.classList.remove("is-dragging");
    }

    root.addEventListener("pointerdown", e => start(e.clientX, e), { passive: false });
    window.addEventListener("pointermove", e => move(e.clientX, e), { passive: false });
    window.addEventListener("pointerup", end);

    root.dataset.p360Inited = "1";
  }

  function boot(scope) {
    (scope || document).querySelectorAll(".p360[data-frames]").forEach(init360);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => boot(document));
  } else {
    boot(document);
  }

  document.addEventListener("shopify:section:load", e => boot(e.target));
})();